import { useBillingAppendixSetups } from '@debbie/cortex/dist/billing-appendix-setups/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { SystemOrTenantSelect } from './SystemOrTenant.js';
const setupId = (setup) => setup.billingAppendixSetupId;
const BillingAppendixSetupSelect = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(SystemOrTenantSelect, { ...props, items: useBillingAppendixSetups(), getId: setupId, labels: {
            placeholder: lang.billingAppendixSetups.selectBillingAppendixSetup,
            search: lang.billingAppendixSetups.searchBillingAppendixSetups,
            all: lang.billingAppendixSetups.billingAppendixSetups,
            system: lang.billingAppendixSetups.systemBillingAppendixSetup,
            tenant: lang.billingAppendixSetups.tenantBillingAppendixSetup,
        }, recentsStorageKey: "debbie.billingAppendixSetupSelect.recentlyUsed" }));
};
export default BillingAppendixSetupSelect;
//# sourceMappingURL=BillingAppendixSetupSelect.js.map